import {router} from 'routing';

const App = () => {
  router();
}

export default App;

